import axios from "axios";

export default axios.create({
    
    baseURL: "https://service-seller.ur2ndlot.com/urs2ndlot_Seller/v1/", 
    // baseURL: "http://localhost:4000/urs2ndlot_Seller/v1/",
      // baseURL: "http://service-dev1seller.ur2ndlot.com/urs2ndlot_Seller/v1/",


    // baseURL: "http://ec2-54-159-173-182.compute-1.amazonaws.com:3000/urs2ndlot_Seller/v1/",
    //baseURL: "http://localhost:4000/urs2ndlot_Seller/v1/", 
});

